import { assertUnreachable } from '@sgme/fp';
import {
  getSecondaryMarketRtFormQuoteId,
  getSecondaryMarketRtFormQuoteStatus as getSecondaryMarketRtFormQuoteStatusFromTab,
  makeGetSecondaryMarketRtFormValidationErrors,
} from 'state/secondaryMarket/realtimeQuote/realtimeQuoteForm/realTimeQuoteForm.selectors';
import { getSecondaryMarketTradeStatus } from 'state/secondaryMarket/realtimeQuote/trade/trade.selectors';
import type { AppState } from 'state/state.model';

import type { SidePanelStatus } from './realtimeQuote/realtimeQuoteForm';
import type { TradeStatus } from './realtimeQuote/trade/trade.model';

export * as cpOrder from 'state/secondaryMarket/cpOrder/cpOrder.selectors';
export * as dlpOrder from 'state/secondaryMarket/dlpOrder/dlpOrder.selectors';
export * as limitOrder from 'state/secondaryMarket/limit-order/limitOrder.selector';
export * as live from 'state/secondaryMarket/live/live.selector';
export * as productSearch from 'state/secondaryMarket/productSearch/productSearch.selectors';
export * as realtimeQuote from 'state/secondaryMarket/realtimeQuote/realtimeQuote.selector';
export * as referential from 'state/secondaryMarket/referential/referential.selector';

export const makeGetSecondaryMarketRtFormStatus: () => (state: AppState, tabId: string) => SidePanelStatus = () => {
  const getValidationErrors = makeGetSecondaryMarketRtFormValidationErrors();
  return (state, tabId) => {
    const errors = getValidationErrors(state, tabId);
    if (errors.length > 0) {
      return 'NOT_READY';
    }
    const quoteStatus = getSecondaryMarketRtFormQuoteStatusFromTab(state, tabId);
    if (quoteStatus === 'NONE') {
      return 'READY';
    }
    if (quoteStatus === 'PENDING') {
      return 'QUOTING';
    }
    if (quoteStatus === 'FAILED') {
      return 'QUOTE_FAILED';
    }
    if (quoteStatus === 'REJECTED') {
      return 'QUOTE_REJECTED';
    }
    const quoteId = getSecondaryMarketRtFormQuoteId(state, tabId);
    const tradeStatus = getSecondaryMarketTradeStatus(state, quoteId!);
    if (tradeStatus === undefined) {
      return 'QUOTED';
    }
    return getWorkflowStatusFromTradeStatus(tradeStatus);
  };
};

function getWorkflowStatusFromTradeStatus(tradeStatus: TradeStatus) {
  switch (tradeStatus) {
    case 'PENDING':
      return 'TRADING';
    case 'DONE':
      return 'TRADED';
    case 'FAILED':
      return 'TRADE_FAILED';
    case 'REJECTED':
      return 'TRADE_REJECTED';
    default:
      return assertUnreachable(tradeStatus, 'Unhandled trade status');
  }
}
